var Bars = new Class({
	Implements: Options,
	options: {
		cls: 'w_bars',
		tracking_label: ''
	},

	initialize: function(_element, options) {
		this._element = _element || document.getElement('.' + this.options.cls);

		if(!this._element) return;

		this.setOptions(options);
		this.build();
	},

	build: function() {
    //Core.add_autoplay_support();
    Core.add_froogaloop();
		this.set_player();

		window.addEvent('beforeunload',function(e) {
			this.players.each(function(player, i){
				this.track_video(player, 'times');
				this.track_video(player, 'percent');
			}.bind(this));
		}.bind(this));
  },

  set_player: function(){
		var _iframes = document.getElements('iframe');
		this.players = [];

		if(!_iframes) return;

		_iframes.each(function(_iframe, i){
			this.players[i] = Froogaloop(_iframe);

			this.players[i].addEvent('ready', function(){
				this.handle_ready();
			}.bind(this));
		}.bind(this));
	},

	handle_ready: function(){
		var self = this;
		this.players.each(function(player, i){
			player.api('setVolume', 0);
			//player.api('play');
			player.counter = 1;

		  player.addEvent('playProgress', function(data){
		  	self.handle_play(player, data);
		  });
		});
	},

	handle_play: function(player, data){
		if(player.vimeo_data && player.vimeo_data.seconds > data.seconds){
			player.counter++;
		}

		player.vimeo_data = data;
	},

	track_video: function(player, type){
		if(!player || !player.vimeo_data) return;

		var val;
		var src = player.element.get('src').split('?');

		if(type == 'percent'){
			val = (player.vimeo_data.percent * 100).round(2);
			val = 'Played Video: ' +  val.toString() + '%';
		}
		else if(type == 'times'){
			val = 'Played Counts: ' + player.counter;
		}

		_gaq.push([
			'_trackEvent',
			this.options.tracking_label, val , src[0]
		]);
	},

	play: function(player) {
		player.api('play');
	},

	pause: function(player) {
		player.api('pause');
	}
});
